(function () {
  'use strict';

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var d = new Date();
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + d.toUTCString();
    }
    document.cookie = name + '=' + (value || '1') + expires + '; path=/; SameSite=Lax';
  }

  function getFromStorage(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function setInStorage(key, value, days) {
    try {
      var item = { v: value, e: days ? Date.now() + days * 24 * 60 * 60 * 1000 : null };
      localStorage.setItem(key, JSON.stringify(item));
    } catch (e) {}
  }

  function hasSeenPopup(container) {
    var name = container.getAttribute('data-cookie-name') || 'popup_gewinnspiel_seen';
    var days = parseInt(container.getAttribute('data-cookie-days') || '7', 10);
    var fromCookie = getCookie(name);
    if (fromCookie) return true;
    var stored = getFromStorage(name);
    if (stored) {
      try {
        var obj = JSON.parse(stored);
        if (obj.e && Date.now() > obj.e) return false;
        return !!obj.v;
      } catch (e) {}
    }
    return false;
  }

  function markAsSeen(container) {
    var name = container.getAttribute('data-cookie-name') || 'popup_gewinnspiel_seen';
    var days = parseInt(container.getAttribute('data-cookie-days') || '7', 10);
    setCookie(name, '1', days);
    setInStorage(name, '1', days);
  }

  function openPopup(container) {
    hideAnnouncement(container);
    container.style.display = '';
    container.classList.add('is-open');
    container.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var firstFocus = container.querySelector('.popup-gewinnspiel__close');
    if (firstFocus) firstFocus.focus();
  }

  function closePopup(container, fromSubmit) {
    container.classList.remove('is-open');
    container.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    markAsSeen(container);
    if (!fromSubmit) {
      showAnnouncement(container);
    }
  }

  function showAnnouncement(container) {
    var sectionId = container.getAttribute('data-section-id');
    var ann = document.querySelector('.popup-gewinnspiel-announcement[data-section-id="' + sectionId + '"]');
    if (ann) ann.classList.add('is-visible');
  }

  function hideAnnouncement(container) {
    var sectionId = container.getAttribute('data-section-id');
    var ann = document.querySelector('.popup-gewinnspiel-announcement[data-section-id="' + sectionId + '"]');
    if (ann) ann.classList.remove('is-visible');
  }

  function goToStage(container, stageNum) {
    var stages = container.querySelectorAll('[data-stage]');
    stages.forEach(function (s) {
      s.classList.remove('is-active');
      if (parseInt(s.getAttribute('data-stage'), 10) === stageNum) {
        s.classList.add('is-active');
      }
    });
  }

  function collectFormData(form) {
    var data = {};
    var inputs = form.querySelectorAll('input, select, textarea');
    inputs.forEach(function (inp) {
      var name = inp.getAttribute('name') || inp.getAttribute('data-field-name');
      if (!name) return;
      var key = name.replace(/^contact\[|\]$/g, '').replace(/^note_/, '');
      if (inp.type === 'radio' || inp.type === 'checkbox') {
        if (inp.checked) data[key] = inp.value;
      } else {
        data[key] = inp.value;
      }
    });
    return data;
  }

  function init() {
    var containers = document.querySelectorAll('.popup-gewinnspiel[data-section-id]');
    containers.forEach(function (container) {
      var overlay = container.querySelector('[data-popup-overlay]');
      var closeBtn = container.querySelector('[data-popup-close]');
      var ctaBtn = container.querySelector('[data-popup-to-form]');
      var form = container.querySelector('[data-popup-form]');
      var shopifyForm = container.querySelector('form#PopupGewinnspielForm');
      var target = container.getAttribute('data-submit-target');
      var externalUrl = container.getAttribute('data-external-url');
      var emailRecipient = container.getAttribute('data-email-recipient');

      function handleClose() {
        closePopup(container, false);
      }

      var ann = document.querySelector('.popup-gewinnspiel-announcement[data-section-id="' + container.getAttribute('data-section-id') + '"]');
      if (ann) {
        ann.addEventListener('click', function () {
          hideAnnouncement(container);
          goToStage(container, 1);
          openPopup(container);
        });
        ann.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            ann.click();
          }
        });
      }

      if (overlay) overlay.addEventListener('click', handleClose);
      if (closeBtn) closeBtn.addEventListener('click', handleClose);

      if (ctaBtn) {
        ctaBtn.addEventListener('click', function () {
          goToStage(container, 2);
        });
      }

      function submitToExternal(data) {
        if (!externalUrl) return Promise.resolve();
        return fetch(externalUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data)
        });
      }

      function submitViaMailto(data) {
        if (!emailRecipient) return;
        var subject = encodeURIComponent('Gewinnspiel-Anmeldung');
        var body = Object.keys(data)
          .map(function (k) { return k + ': ' + data[k]; })
          .join('%0A');
        var mailto = 'mailto:' + emailRecipient + '?subject=' + subject + '&body=' + encodeURIComponent(body);
        window.location.href = mailto;
      }

      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var data = collectFormData(form);
          var submitBtn = form.querySelector('[type="submit"]');
          if (submitBtn) submitBtn.disabled = true;

          if (target === 'external_url') {
            submitToExternal(data).then(function () {
              markAsSeen(container);
              closePopup(container, true);
              if (submitBtn) submitBtn.disabled = false;
            }).catch(function () {
              if (submitBtn) submitBtn.disabled = false;
            });
          } else if (target === 'email') {
            submitViaMailto(data);
            markAsSeen(container);
            closePopup(container, true);
            if (submitBtn) submitBtn.disabled = false;
          }
        });
      }

      if (shopifyForm) {
        shopifyForm.addEventListener('submit', function () {
          markAsSeen(container);
          closePopup(container, true);
          if (target === 'shopify_and_external' && externalUrl) {
            var data = collectFormData(shopifyForm);
            submitToExternal(data);
          }
        });
      }

      if (!hasSeenPopup(container)) {
        openPopup(container);
      } else {
        showAnnouncement(container);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
